import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Megaphone } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AnnouncePanel = ({ auth }) => {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => axios.get(`${API}/admin/announce/loyalty`, auth()).then((r) => setInfo(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!info?.running) return undefined;
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [info?.running]); // eslint-disable-line react-hooks/exhaustive-deps

  const start = async () => {
    if (!window.confirm(`Inviare l'annuncio della tessera a ${info.to_send} clienti? Ogni cliente lo riceve una sola volta.`)) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/announce/loyalty`, {}, auth());
      setInfo(data);
      toast.success("Invio avviato");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore");
    } finally {
      setBusy(false);
    }
  };

  if (!info) return null;
  return (
    <div data-testid="announce-panel" className="rounded-2xl bg-[#0B1F3A] text-[#F7F2EC] p-5 sm:p-6 mb-8 flex flex-col sm:flex-row sm:items-center gap-5">
      <div className="flex-1">
        <p className="font-mono-alt text-[11px] uppercase tracking-[0.3em] text-[#F7F2EC]/60 mb-2">Annuncio tessera</p>
        <p data-testid="announce-to-send" className="font-display text-2xl font-bold">{info.to_send} clienti da avvisare</p>
        <p data-testid="announce-stats" className="text-xs text-[#F7F2EC]/70 mt-1">
          {info.total_emails} email salvate · {info.with_card} hanno già la tessera · {info.sent} avvisati · {info.failed} non riusciti{info.unsubscribed ? ` · ${info.unsubscribed} disiscritti` : ""}
        </p>
        <p className="text-[11px] text-[#F7F2EC]/50 mt-2">L'email ha il bottone "Attiva la mia tessera" e il link per non ricevere più novità.</p>
      </div>
      <button data-testid="announce-send-button" onClick={start} disabled={busy || info.running || info.to_send === 0}
        className="inline-flex items-center justify-center gap-2 rounded-full bg-[#F7F2EC] text-[#0B1F3A] px-6 py-3.5 text-xs font-bold uppercase tracking-[0.12em] hover:bg-white disabled:opacity-50 transition-colors">
        {busy || info.running ? <Loader2 className="w-4 h-4 animate-spin" /> : <Megaphone className="w-4 h-4" />}
        {info.running ? "Invio in corso…" : "Invia annuncio"}
      </button>
    </div>
  );
};
